import React from "react";


import {
    Navigate
} from "react-router-dom";


import {
    UseQyvoUser
} from "@Store/@Hooks";


import {
    PageContainerComponent
} from "@Components/Sections";


import {
    HeadSectionComponent
} from "@Parts/Sections";


import SignInPageFormComponent from "@Pages/@@UserPages/@SignIn/SignInForm";


import headImage from "@Images/head-image.svg";


export const SignInPage:React.FC = () => {


    const QyvoUser = UseQyvoUser();

    if (QyvoUser) {
        return <Navigate to={'/dashboard'} replace />;
    }

    return (
        <PageContainerComponent pageType={'sign-in-page'}>

            <HeadSectionComponent
                pageName={'sign-in-page'}
                sectionHeaderText={'Sign In'}
                sectionSubText={'Sign in to your account'}
                sectionImage={headImage}
            />

            <SignInPageFormComponent />

        </PageContainerComponent>
    );

};


export default SignInPage;
